import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { GroupService } from 'src/app/services/repositories/group.service';
import { Response } from 'src/app/interfaces/Response';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PostService } from 'src/app/services/repositories/post.service';
import { SocialMediaAPIService } from 'src/app/services/utilities/socialMediaApi.service';
import { ICON } from 'src/app/interfaces/ModalIcon';
import { Debug } from 'src/app/utils/debug';
import { WebSocketService } from 'src/app/services/utilities/websocket.service';
import { environment } from 'src/environments/environment';
import { QueueService } from 'src/app/services/utilities/queue.service';

@Component({
  selector: 'app-group-manager',
  templateUrl: './group-manager.component.html',
  styleUrls: ['./group-manager.component.scss'],
})
export class GroupManagerComponent {
  res: Response = {
    data: [],
    navigation: {
      page: 0,
      totalPages: 0,
      totalRows: 0,
      itemsPerPage: 0,
    },
    success: false,
    error: '',
    status: 0,
  };
  private groupsSubscription: Subscription | undefined;
  isParentSkipped: boolean = false;
  hasSagammLogo: boolean = false;
  isGroupFake: boolean = false;
  constructor(
    private groupService: GroupService,
    private postService: PostService,
    private socialMediaApiService: SocialMediaAPIService,
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private webSocketService: WebSocketService,
    private queueService:QueueService
  ) {}
  newGroupForm!: FormGroup;

  rootGroups: any;
  isModalOpen: boolean = false;
  modalIcon: ICON = ICON.success;
  isGroupImageUrlOpen:boolean = false;
  selectedFile:any
  subscriptions: Subscription[] = [];
  activePages:any[]=[]
  @Output() UpdateGroups = new EventEmitter<any>();

  ngOnInit() {

    this.syncQueueJob()
    this.webSocketService.connect();
    this.webSocketService.listen('postDownloadEnded', (data: any) => {
      console.log('[SOCKETEVENT] - postDownloadEnded', data);
      this.syncQueueJob()
      console.log(this.res.data)
      const page = this.currentGroup.socialMedia.find((p:any)=>p.id==data.id)
      const index = this.currentGroup.socialMedia.indexOf(page)
      if(index!=-1){
        this.currentGroup.socialMedia[index].updated = data.downloadedAndExisting
        this.currentGroup.socialMedia[index].new = data.newlyDownloaded
        this.currentGroup.socialMedia[index].isDownloading = false
        this.currentGroup.socialMedia[index].isSynching = true
      }
      
    })
    this.webSocketService.listen('postSyncEnded', (data: any) => {
      console.log('[SOCKETEVENT] - postSyncEnded', data);
      this.activePages = this.activePages.filter((p:any)=>{p.id!=data.id})
      this.refreshGroups()
    })
    this.newGroupForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      logoUrl: [''],
      clientSatisfactionId:[''],
      hasSagammLogo:[false],
      isGroupFake:[false]
    });

    this.subscriptions.push( this.groupService.getGroups().subscribe(
      (response: Response) => {
        this.res = response; // Assign the full IResponse object
        console.log()
        this.res.data = this.res.data.map((g) => {
          g.Subgroups = g.children?.length;
          
          return g;
        });
      },
      (error) => console.error('Error fetching groups:', error)
    ));

    this.subscriptions.push(this.groupService.getStructuredGroups().subscribe((res) => {
      this.rootGroups = res;
      // Debug.log("group tree",this.rootGroups)
      this.rootGroups.data = this.rootGroups.data.map((g: any) => {
        g.Subgroups = g.children?.length;
        return g;
      });

    }));

  }

  syncQueueJob(){
    this.queueService.getJobInfo('syncPostQueue').subscribe((res:any)=>{
      console.log("!!! QUEUE DOWNLOADED !!")
      this.activePages=[]
      res.ACTIVE.jobs.forEach((j:any)=>{
        let page = j.data.page
        page.isDownloading = false
        page.isSynching = true
        page.isDone = false
        page.isActive=true
        this.activePages.push(page)
      })

      res.WAITING.jobs.forEach((j:any)=>{
        let page = j.data.page
        page.isDownloading = true
        page.isSynching = false
        page.isDone = false
         page.isActive=false
        this.activePages.push(page)
      })
      //this.activePages = [...new Set(this.activePages.map((p:any)=>JSON.stringify(p)))].map((p:any)=>JSON.parse(p))
      console.log(this.activePages.map((p:any)=>{return{id:p.id,name:p.name,isDownloading:p.isDownloading,isSynching:p.isSynching}}))
      this.res.data.forEach((g: any) => {
        g.socialMedia.forEach((p: any) => {
          const found = this.activePages.find((sm: any) => sm.id === p.id);
          if (found) {
            p.isDownloading = found.isDownloading;
            p.isSynching = found.isSynching;
          }
        });
      });
    })
  }
  refreshGroups(){
    
    // this.res.data.forEach((g:any)=>{
    //   g.forEach((sm:any)=>{
    //       if(this.activePages.map((p:any)=>p.id).includes(sm.id)){
    //         sm = this.activePages.find((p:any)=>p.id==sm.id)
    //       }
    //   })
    // })
  }

  setGroupURLImage(data: any) {
    this.selectedFile = {
      imageChangedEvent: this.selectedFile?.imageChangedEvent || null,
      croppedImage: data.blob, // Set the confirmed cropped image
      ...data
    };
    console.log("selectedFile after cropping",this.selectedFile)
    this.isGroupImageUrlOpen = false;
  }

  isGroupParentValid() {
    return this.isParentSkipped || this.selectedGroup != undefined;
  }
  updateCheckbox() {
    this.isParentSkipped = !this.isParentSkipped;
    this.cdRef.detectChanges();
  }
  updatePartnerCheckBox(){
    this.hasSagammLogo = !this.hasSagammLogo;
    this.newGroupForm.patchValue({hasSagammLogo: this.hasSagammLogo})
    this.cdRef.detectChanges();
  }

  updateGroupFakeCheckBox(){
    this.isGroupFake = !this.isGroupFake;
    this.newGroupForm.patchValue({isGroupFake: this.isGroupFake})
    this.cdRef.detectChanges();
  }

  onUpdateGroups() {
    this.groupService
      .getDataByPage(this.res.navigation.page, this.res.navigation.itemsPerPage)
      .subscribe((res) => {
        this.res = res;
        this.res.data = res.data.map((g) => {
          g.children = g.children.length;
          //reset group image
          this.selectedFile=null
          return g;
        });
      });
  }

  fetchGroupTree() {
    this.subscriptions.push(this.groupService.getStructuredGroups().subscribe((res) => {
      this.rootGroups = res;
      this.UpdateGroups.emit(res);
      this.rootGroups.data = this.rootGroups.data.map((g: any) => {
        g.Subgroups = g.children?.length;
        return g;
      });
    }));
  }
  currentGroup: any = {};
  processedPageQueue:number=0

  PagesWithPendingActions:any[]=[]
  showFetchPostsModal(group: any) {
    this.syncQueueJob()
    this.isFetchModalOpen = true;
    this.currentGroup = group;
    for(let g of this.res.data){
      if(g.id==this.currentGroup.id){
        g.socialMedia == this.currentGroup.socialMedia
      }
    }
    // console.log(this.res.data.find((g:any)=>g.id==this.currentGroup.id) )
  }

  isFetchModalOpen = false;
  createNewGroup() {
    //upload the selectedFile if any
    if(this.selectedFile) {
      this.subscriptions.push(this.groupService.uploadFile(this.selectedFile).subscribe((data:any) => {
        // console.log("uploadedImage response",data);
        this.newGroupForm.patchValue({logoUrl: data?.files[0]?.url})
        this.prepareDataForSubmit()
      }))
    }
    else{
      this.prepareDataForSubmit()
    }
  }

  clearJob(data:any){
    this.queueService.removeJobFromQueue("syncPostQueue",data).subscribe((res:any)=>{
      console.log("clearjob response",res)
      this.syncQueueJob()
    })
  }
  pagesOf(source:string){
    return this.currentGroup.socialMedia.filter((p:any)=>p.source==source)
  }
  prepareDataForSubmit(){
    const newGroup = {
      ...this.newGroupForm.value,
      parentId:
        !this.isParentSkipped && this.selectedGroup
          ? this.selectedGroup.id
          : null,
    };

    console.log("⚠️ new group befor inserting",newGroup)
    this.groupService.addGroup(newGroup).subscribe(()=>{
      this.selectedFile = null
    });
    this.fetchGroupTree();
    //update navigation on table component
    this.updateGroupTreeForTable();

    // rest new group form
    this.newGroupForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      logoUrl: [''],
      clientSatisfactionId:[''],
      hasSagammLogo:[false],
      isGroupFake:[false]
    });
    this.hasSagammLogo = false;
    this.isGroupFake = false;
    this.isParentSkipped = false;
    this.selectedGroup = null;
    this.isModalOpen = true;
    setTimeout(() => {
      this.isModalOpen = false;
    }, 2000);
  }
  updateGroup(data: any) {
    const group = {
      id: data.item.id,
      name: data.item.name,
      logoUrl: data.item.logoUrl,
      parentId: data.item.parentId,
      ancestryIds: data.item.ancestryIds,
      clientSatisfactionId: data.item.clientSatisfactionId,
      hasSagammLogo: data.item.hasSagammLogo,
      isGroupFake: data.item.isGroupFake
    };
    if(this.selectedFile){
      this.subscriptions.push(
        this.groupService.uploadFile(this.selectedFile).subscribe((res: any) => {

          const newUrl = res.files[0].url;
          data.item.logoUrl = newUrl;  
          group.logoUrl = newUrl;       

          this.subscriptions.push(
            this.groupService.updateGroup(data.item.id, group).subscribe((res: any) => {
              data.item = res.data;
              this.updateGroupTreeForTable();
              this.selectedFile = null;
            })
          );
        })
      );
    }
    else{
      console.log("updating group without new image")
      this.subscriptions.push(this.groupService.updateGroup(data.item.id, group).subscribe((res:any)=>{
        console.log("group updated",res.data)
        data.item = res.data
        this.updateGroupTreeForTable();
      }));
    }
  }

  deleteGroup(data: any) {
    this.subscriptions.push(this.groupService.deleteGroup(data.item.id).subscribe());
    this.updateGroupTreeForTable();
  }

  updateGroupTreeForTable() {
    this.subscriptions.push(this.groupService.getStructuredGroups().subscribe((res) => {
      this.rootGroups = res;
      // Debug.log("group tree",this.rootGroups)
      this.rootGroups.data = this.rootGroups.data.map((g: any) => {
        g.Subgroups = g.children?.length;
        return g;
      });
      Debug.log('the group root got updated to', this.rootGroups);
    }));
  }

  //#region navigation
  selectedGroup: any;
  updateSelectedParentGroup(data: any) {
    this.selectedGroup = data;
  }

  getGroupsFirstPage() {}

  getGroupsNextPage() {
    Debug.log('loading next groups page');
  }

  getGroupsPreviousPage() {
    Debug.log('loading previous groups page');
  }

  getGroupsLastPage() {
    Debug.log('loading last groups page');
  }
  //#endregion

  openFetchPostsModal(group: any) {
    Debug.log('loading first groups page event  triggred on group-manager');
    Debug.log(group.socialMedia);
  }

  closeFetchPostsModal() {
    this.isFetchModalOpen = false;
  }

   process(pagesIds:Number[]){
    if(this.activePages.length<2){
      this.currentGroup.socialMedia.forEach((p:any)=>{
        if(pagesIds.includes(p.id)){
          console.log("processing page", p.name)
          this.activePages.push(p)
          p.isDone=false
          p.isDownloading=true
          this.subscriptions.push(this.socialMediaApiService.fetchPagePosts(pagesIds).subscribe())
        }
      })
    }
    else{
      console.log(`cannot exceed `,this.activePages.length,"active page fetch")
    }
  }


  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.webSocketService.disconnect();
  }
}
